import type { LocalDatabasePageRule } from "../../../_Generated/Sync.gen";
import type { BasePageRuleRepository } from "../../_Bases/BasePageRuleRepository";
import type { InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBPageRuleRepository extends BaseIndexedDBRepository<
    LocalDatabasePageRule
> implements BasePageRuleRepository {
    public readonly source: InternalIndexedDBDatabase["pageRules"];
    protected readonly dataTypeName = "Page Rule";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.pageRules;
    }
}
